/* eslint-disable react-hooks/exhaustive-deps */
import React from "react"
import { Box } from "@chakra-ui/react"
import SendMessage from "./mobileSendMessage"
import { MobileChatStream } from "./mobileChatStream"
import { ChatPolls } from "../../servicesPanel/polls/chat-polls"
import { useRecoilValue, useSetRecoilState } from "recoil"
import layoutStates from "../../../recoil/atoms/layout"
import { Poll } from "../../servicesPanel/polls/polls.interfaces"
import { useWatchParty } from "../../../hooks/useWatchParty"
import { chatAttachmentHeightSelector, chatIsReadSelector, selectedReplyAtom } from "../../../recoil/atoms/chats"
import { useLocalUserType } from "../../../hooks/useLocalUserType"
import useLocalUserHasPermissions from "../../../hooks/useLocalUserHasPermissions"
import { pollsAtom } from "../../../recoil/atoms/polls"
import { scroller } from "react-scroll"
import { hasPermission } from "../../../util"
import { scrollToBottomContainer } from "../../../util/scrollTo"
import { badgeHistoryListSelector } from "../../../recoil/atoms/badgeHistory"
import useWindowSize from "../../../hooks/useWindowSize"
import { urlBarNarrowed } from "../../../util"
import { useBrowserType } from "../../../hooks/useBrowserType"
import { showTabsAtBottomOnMobileSelector } from "../../../recoil/atoms/room"
import { ElementId } from "../../../constants/enums"

const UserPermission = window.MeetOnline.UserPermission

interface MobileChatProps {
  chatSize: {
    width: number | null
    height: number | null
  }
  isTransparent?: boolean
  isTablet?: boolean
  isFullWidth?: boolean
  nameLocalUser: string
  localUserProperties: any
  hideTabs?: boolean
  isTabs: boolean
  isLandscape: boolean
}

const MobileChat: React.FC<MobileChatProps> = React.memo(
  ({
    isTransparent,
    chatSize,
    isTablet,
    isFullWidth,
    nameLocalUser,
    localUserProperties,
    hideTabs,
    isTabs,
    isLandscape
  }) => {
    const { isAudience, isModerator } = useLocalUserType()
    const { isWatchParty } = useWatchParty()
    const { isSafariMobile } = useBrowserType()
    const { canSeeHistory } = useLocalUserHasPermissions()
    const setIsChatTab = useSetRecoilState<boolean>(layoutStates.isChatTab)
    const setChatIsRead = useSetRecoilState<boolean>(chatIsReadSelector)
    const polls = useRecoilValue(pollsAtom)
    const allBadgeHistory = useRecoilValue(badgeHistoryListSelector)
    const showTabsAtBottomOnMobile = useRecoilValue(
      showTabsAtBottomOnMobileSelector
    )
    const isAnyReplySelected = useRecoilValue(selectedReplyAtom)

    const handleScrollToBottomChat = React.useCallback(() => {
      setChatIsRead(true)
      scroller.scrollTo("bottom-chat", {
        duration: 100,
        delay: 100,
        smooth: true,
        containerId: "messages-container-mobile"
      })
    }, [setChatIsRead])

    const mobileChatContainerHeight = React.useMemo(() => {
      return chatSize.height
    }, [chatSize.height])

    const setFsInterfaceTab = useSetRecoilState<string>(
      layoutStates.fsInterfaceTab
    )

    const paddingChat = React.useMemo(() => {
      if (isFullWidth) {
        return "0"
      }
      return isTablet ? "0px" : "0px"
    }, [isTablet, isFullWidth])

    const scrollToBottom = React.useCallback(async () => {
      scrollToBottomContainer(ElementId.MOBILE_CHAT_CONTAINER, 300)
    }, [])

    React.useEffect(() => {
      setFsInterfaceTab("chat")
      setIsChatTab(true)
      let timer = setTimeout(() => {
        handleScrollToBottomChat()
      }, 300)
      return () => clearTimeout(timer)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const selectedPolls: Poll[] = React.useMemo(
      () => polls.filter(el => el.isVisible === true),
      [polls]
    )

    const isTab = React.useMemo(() => {
      return (
        !hideTabs &&
        (isModerator ||
          hasPermission(
            localUserProperties?.permissions,
            UserPermission.canUseChat
          ))
      )
    }, [isModerator, localUserProperties?.permissions, hideTabs])

    const handleScrollChatWhenReturnToTab = event => {
      if (document.visibilityState === "visible") {
        scrollToBottom()
      }
    }

    React.useEffect(() => {
      document.addEventListener(
        "visibilitychange",
        handleScrollChatWhenReturnToTab
      )
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleScrollChatWhenReturnToTab
        )
      }
    }, [])

    const { screenSize } = useWindowSize()

    const isUrlBarNarrowed = React.useMemo(() => {
      return urlBarNarrowed() && isSafariMobile
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screenSize.height])

    const chatBottomMargin = showTabsAtBottomOnMobile
      ? "58px"
      : canSeeHistory && allBadgeHistory.length > 0
      ? isUrlBarNarrowed
        ? "110"
        : !isTabs
        ? "58px"
        : "98px"
      : !isTabs
      ? "58px"
      : "98px"

    const chatAttachmentHeight = useRecoilValue(chatAttachmentHeightSelector)
    const chatBottomMarginWithReplyMessage = `calc(
      ${chatBottomMargin} + 
      ${isAnyReplySelected ? "64px" : "0px" } + 
      ${chatAttachmentHeight ? chatAttachmentHeight + 32 : 0}px)`

    return (
      <>
        <Box
          display="flex"
          pt={paddingChat}
          flexDirection="column"
          justifyContent="space-between"
          height={`${mobileChatContainerHeight}px`}
          className="chat"
          /* bg={roomStyles?.servicePanelColor ?? "#F7FAFC"} */
        >
          {isTab && (
            <Box
              w="full"
              px="8px"
              paddingTop={selectedPolls.length === 0 && "8px"}
              overflowY="auto"
              d="flex"
              flexDirection="column-reverse"
              flexGrow={1}
              // marginBottom={chatBottomMarginWithReplyMessage}
              pos="relative"
            >
              <Box h="100%" width="100%" display="flex">
                <MobileChatStream
                  isMobile={true}
                  isTablet={isTablet}
                  scrollToBottom={scrollToBottom}
                />
              </Box>
            </Box>
          )}
            
          <Box w="100%">
            <SendMessage
              isLandscape={isLandscape}
              isTransparent={isTransparent}
              scrollToBottom={scrollToBottom}
              isAudience={isAudience}
              isUrlBarNarrowed={isUrlBarNarrowed}
              showTabsAtBottomOnMobile={showTabsAtBottomOnMobile}
              id="mobile-input"
            />
          </Box>
        
        </Box>
      </>
    )
  }
)

export default MobileChat
